import { ofNews } from "../types/news";
import { GridColDef } from "@mui/x-data-grid";
import { parseISO } from "date-fns";
import { ImageColumn } from "../components/table/ImageColumn";

export const newsCols: GridColDef[] = [
  {
    field: ofNews("image"),
    headerName: "Image",
    renderCell: function render({ row }) {
      return (
        <ImageColumn
          imageUrl={row.image?.url}
          borderRadius={"10%"}
          maxWidth={8}
        />
      );
    },
  },
  {
    field: ofNews("title"),
    headerName: "Title",
    flex: 1,
  },
  {
    field: ofNews("externalUrl"),
    headerName: "External link",
    flex: 1,
  },
  {
    field: ofNews("publishAt"),
    headerName: "Publish Date",
    flex: 1,
    valueFormatter: (value) => parseISO(value as string).toLocaleString(),
  },
];
